import { useInfiniteQuery } from "@tanstack/react-query";
import { DateTime } from "luxon";
import { getVivaTransactionsApi } from "../api/vivaApi";
import type { PaymentMethodId, StoreId } from "@KassaroAB/shared/types/ids";

export const VIVA_TRANSACTIONS_MAX_DAYS = 90;

const previousDate = (date: string, fromDate: string): string | undefined => {
  const previous = DateTime.fromISO(date).minus({ days: 1 });
  const oldest = DateTime.fromISO(fromDate).minus({
    days: VIVA_TRANSACTIONS_MAX_DAYS - 1,
  });
  return previous < oldest ? undefined : previous.toISODate() ?? undefined;
};

export const useGetInfiniteVivaTransactionsQuery = (
  storeId: StoreId | undefined,
  paymentMethodId: PaymentMethodId | undefined,
  fromDate: string,
) => {
  return useInfiniteQuery({
    queryKey: [
      "stores",
      storeId,
      "paymentMethods",
      paymentMethodId,
      "vivaTransactions",
      fromDate,
    ],
    queryFn: ({ pageParam }: { pageParam: string }) =>
      getVivaTransactionsApi(storeId!, paymentMethodId!, pageParam),
    initialPageParam: fromDate,
    getNextPageParam: (lastPage) => previousDate(lastPage.date, fromDate),
    enabled: !!storeId && !!paymentMethodId && !!fromDate,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
